

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectCrawlComponent } from './select-crawl.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [SelectCrawlComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    
  ],

  exports: [SelectCrawlComponent],
  entryComponents: [SelectCrawlComponent],
})
export class SelectCrawlModule { }
